import {useSelector} from "react-redux";

export default function () {
    const organization = useSelector(state => state.organizations.organization);
    const loadingOrganization = useSelector(state => state.organizations.loading);
    return { organization, loadingOrganization };
}